import sortByKey from "./sortByKey";

interface Props {
    sortKey: string;
    unsortedTableRows: Record<string, any>[];
    reversed?: boolean;
}

const getSortedTableRows = ({
    sortKey,
    reversed = false,
    unsortedTableRows,
}: Props): Record<string, any>[] => {
    // Need to use slice() to recompute array of same length but different elements
    const sortedData = sortByKey(unsortedTableRows.slice(), sortKey);
    if (reversed) return sortedData.reverse();
    return sortedData;
};

export default getSortedTableRows;
